import { TaskGroupBy, TaskLinkType } from './task.enum';

export interface TaskViewOptions {
    groupBy: TaskGroupBy;
    sortBy: TaskGroupBy;
    sortOrder: 'asc' | 'desc';
    filterValue: any;
    entityName: TaskLinkType;
    showEmptyGroups?: boolean;

    /** Task id that must stay visible even if it doesn't match filterValue (e.g. a just-created task). Cleared on the next filter change. */
    alwaysIncludeTaskId?: string;

    /** #WBS-2956 Not sure what is for */
    options: {
        showEmptyGroups: boolean
    }
}

export const defaultViewOptions: TaskViewOptions = {
    groupBy: TaskGroupBy.None,
    sortBy: TaskGroupBy.None,
    sortOrder: 'asc',
    filterValue: null,
    entityName: null,
    showEmptyGroups: false,

    /** #WBS-2956 Not sure what this for */
    options: {
        showEmptyGroups: false
    }
}